import React from 'react';
import Table from '../../Table';
import { formatCents } from './affiliateForm';

export default function AffiliateCodesTable({ codes, performanceByCode, onEdit, onStatus }) {
  return (
    <Table
      className="affiliate-codes-table"
      data={codes}
      keyField="uuid"
      columns={[
        {
          key: 'displayCode',
          header: 'Code',
          render: (value, row) => (
            <div>
              <strong>{value || row.code}</strong>
              {row.name && <small>{row.name}</small>}
            </div>
          ),
        },
        {
          key: 'status',
          header: 'Status',
          render: value => <span className={`affiliate-status ${value}`}>{value}</span>,
        },
        {
          key: 'redemptions',
          header: 'Referrals',
          render: (value, row) => performanceByCode[row.id]?.redemptions?.total || 0,
        },
        {
          key: 'commission',
          header: 'Net commission',
          render: (value, row) => formatCents(
            performanceByCode[row.id]?.commission?.net || 0,
          ),
        },
        {
          key: 'tools',
          header: 'Tools',
          render: (value, row) => (
            <div className="affiliate-table-actions">
              <button type="button" onClick={() => onEdit(row)}>Edit</button>
              {row.status !== 'suspended' && (
                <button
                  type="button"
                  onClick={() => onStatus(row, row.status === 'active' ? 'paused' : 'active')}
                >
                  {row.status === 'active' ? 'Pause' : 'Activate'}
                </button>
              )}
            </div>
          ),
        },
      ]}
    />
  );
}
